import React from 'react'

const Play = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M20.8715 14.6422C21.1223 14.4481 21.3253 14.1992 21.4649 13.9145C21.6046 13.6298 21.6772 13.3169 21.6772 12.9999C21.6772 12.6828 21.6046 12.3699 21.4649 12.0852C21.3253 11.8005 21.1223 11.5516 20.8715 11.3575C17.6239 8.84545 13.998 6.86501 10.1292 5.49018L9.42178 5.23885C8.06978 4.75893 6.64086 5.67327 6.45778 7.06969C5.94645 11.0066 5.94645 14.9931 6.45778 18.93C6.64195 20.3264 8.06978 21.2408 9.42178 20.7609L10.1292 20.5095C13.998 19.1347 17.6239 17.1543 20.8715 14.6422Z" fill="currentColor"></path>
</svg>
    )
}

export default Play
